import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as me from '../../../me'
import type { TypeParams } from '../types'

/**
 * Refreshes the current user's access tree after creating a zone.
 *
 * Zone creation grants backend access to the creator, so Admin Center route
 * guards need fresh `Me` state before the user opens the new zone.
 */
export const refreshMeOnCreateSuccess = store.effects.create(
  (
    _: ec.Collection<TypeParams>['feature'],
    zonesEc: ec.Collection<TypeParams>,
    meFeature: me.Feature,
  ) =>
    zonesEc.plugins.dataOperationPlugin.feature.actions.create.success
      .observe()
      .pipe(rxjs.map(action => meFeature.actions.get.from(action).create())),
)
